<template>
    <div>

        <v-card :color="color" :height="height" class="elevation-2">
            <v-card-text class="text-center pa-0">
                <v-btn style="font-weight: 400;" class="text-none" @click="clickButton" :color="textColor"
                    variant="tonal" :height="height" width="100%">
                    <LanguagePlaceholder :default-text="props.buttonText" />

                </v-btn>
            </v-card-text>
        </v-card>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()

const height = ref(40)

const buttonText = ref('')
const color = ref('#e5f6ff')
const textColor = ref('#055699')
const fileName = ref('')
const container = ref('')


const props = defineProps({
    buttonText: { type: String, default: '', required: true },
    color: { type: String, default: '' },
    textColor: { type: String, default: '' },
    fileName: { type: String, default: '', required: true },
    container: { type: String, default: '', required: true }
})


onMounted(() => {
    buttonText.value = props.buttonText
        color.value = props.color
        textColor.value = props.textColor
        fileName.value = props.fileName
        container.value = props.container
})

watch(
    () => props.buttonText, (val) => {
        // buttonText.value = val
    }
)

const clickButton = () => {
    var baseUrl = 'https://dellpartnerincentives.com/files/'
    var fileUrl = baseUrl + fileName.value
    systemStore.openUrl(fileUrl)

    // systemStore.getFile(fileName.value, container.value).then(res => {
    //     if (res.success === true) {

    //         systemStore.openUrl(res.fileUrl)
    //     }
    // }).catch(error => {
    //     console.log(error)
    // })
}
</script>
